<template>
  <div class="h5-bank-payment">
    <div class="h5-bank-payment__header">
      <Icon
        class="h5-bank-payment__back"
        name="icon-arrow-left-l"
        @click="$router.back()"
      />
      <p>Transfer Information</p>
    </div>
    <div class="h5-bank-payment__content">
      <H5BankPaymentContent
        v-if="orderInfo"
        :price="orderInfo.b2bOrderVo.totalAmountUsd"
        :order-no="orderInfo.b2bOrderVo.orderNo"
        @confirm="handleBankPaymentConfirm"
        @cancel="$router.replace('/orders?status=1')"
      />
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import H5BankPaymentContent from './components/H5BankPaymentContent.vue'
import { fetchData } from '@/utils/fetch'
import { metaPixelTrack } from '@/utils/utils'

const route = useRoute()

const orderInfo = ref(null)

const getOrderInfo = async () => {
  const { code, data } = await fetchData('/appb/b2b/order/page', {
    method: 'POST',
    body: JSON.stringify({
      orderNo: route.params.orderNo
    }),
    failedRedirect: true
  })
  if (code === 200) {
    orderInfo.value = data.rows[0]
  }
}

const handleBankPaymentConfirm = () => {
  if (orderInfo.value == null) return
  const list = orderInfo.value.b2bOrderDetails
  /**
   * Meta Pixel 埋点：银行转账提交支付审核
   */
  metaPixelTrack('POP401', 'Purchase', {
    content_ids: [...new Set(list.map((item) => item.spuId))],
    content_type: 'product_group',
    currency: '$',
    value: 9,
    num_items: list.reduce((total, cur) => {
      total += cur.skuQuantity
      return total
    }, 0)
  })
}

onBeforeMount(() => {
  getOrderInfo()
})
</script>

<style lang="less" scoped>
.h5-bank-payment {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000000;
  color: #232323;

  &__header, &__content {
    border-radius: 8px;
    background-color: #FFFFFF;
  }

  &__header {
    flex-shrink: 0;
    position: relative;
    margin: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    height: 48px;
    font-family: mon-700;
    font-size: 14px;
    line-height: 18px;
  }

  &__back {
    position: absolute;
    left: 12px;
    top: 12px;
    font-size: 24px;
  }

  &__content {
    flex: 1;
    margin: 0 12px 12px;
    overflow-y: auto;
  }
}
</style>
